export default __webpack_public_path__ + "static/media/down-arrow.1918a115.webp";